import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import initCornerstone from './Environment/initCornerstone';
import { AuthProvider } from './Modules/Auth/AuthContext';
import { PrivateRoute,EditRoute } from './Modules/Auth/PrivateRoute';

import { Header } from './Pages/Header';
import { Footer } from './Pages/Footer';
import { Home } from './Pages/Home';
import { NotFound } from './Pages/Error/NotFound';

import { Login } from './Pages/Login/Login';
import { LoginForms } from './Pages/Login/LoginForms';

import Basic from './Pages/Basic/Basic';
import { BasicMenu } from './Pages/Basic/BasicMenu';

import Mypage from './Pages/MyPage/Mypage';
import ChangeForms from './Pages/MyPage/CangeForms';

import CaseCatalogue from './Pages/Catalogue/Search';
import CatalogueAuthSelect from './Pages/Catalogue/CatalogueAuthSelect';
import CatalogueManagement  from './Modules/Management/CatalogueManagement';
import classes from './Functions/Style/style.module.css'

import './App.css';
import { Container } from '@mui/material';
import DiseaseEdit from './Modules/Management/DiseaseEdit';

import DiseasePage from './Pages/Catalogue/DiseasePage';

import DiseaseManagement from './Modules/Management/DiseaseManagement';

import DiseaseAdd from './Modules/Management/DiseaseAdd';
import Search from './Pages/Catalogue/Search';
import Disease from './Pages/Catalogue/Disease';
import MStudyPage from './Pages/MStudy/MStudyPage';
import MStudyList from './Pages/MStudy/MStudyList';

// cornerstone tools の初期化
initCornerstone();

function HeaderFooter({ component }: {component: JSX.Element }) {

  return (
   <AuthProvider children={
      <PrivateRoute>
        <div>
          <Header></Header>
          {component}
          <Footer></Footer>
          {/* <newFooter></newFooter> */}
        </div>
      </PrivateRoute>
   }></AuthProvider>
  )
}

function App() {
  
  /*
  React.useEffect(() => {
    const preventScreenshot = (event:Event) => {
      event.preventDefault();
      window.alert('こちらのページでは右クリックができません。');
    };
  
    // スクリーンショットを防止するためのイベントハンドラを追加
    //document.addEventListener('keydown', preventScreenshot);
    //本番はこれを加える
    //document.addEventListener('contextmenu', preventScreenshot);
  
    return () => {
      // コンポーネントのアンマウント時にイベントハンドラを削除
      //document.removeEventListener('keydown', preventScreenshot);
      //本番はこれを加える
      //document.removeEventListener('contextmenu', preventScreenshot);
    };
  }, []);
  */

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={
            <AuthProvider children={
              <div>
                <Header></Header>
                <Home></Home>
                <Footer></Footer>
              </div>
            } />}>            
          </Route>
          <Route path="/login/" element={
            <AuthProvider children={<Login />}
            />} />
          <Route path="/forms/" element={
            <AuthProvider children={<LoginForms />} />
          } />
          <Route path="/basic" element={
            <HeaderFooter component={<BasicMenu />} />
          }
          />
          <Route path="/basic/:sitekind" element={
            <HeaderFooter component={<Basic />} />
          } />
          <Route path="/mypage/changeforms" element={
            <AuthProvider children={
              <PrivateRoute>
                <ChangeForms></ChangeForms>
              </PrivateRoute>
            } />
          } />
          <Route path="/mypage/:MypageKind" element={
            <HeaderFooter component={
              <Mypage />
            } />}
          />
          <Route path="/mypage/:MypageKind/:ActionKind" element={
            <HeaderFooter component={
              <Mypage />
            } />}
          />
          <Route path="/mypage/:MypageKind/:ActionKind/:ObjectId" element={
            <HeaderFooter component={
              <Mypage />
            } />}
          />
                    
          
          <Route path="catalogue/case/:uploaderId/:CatalogueId" element={
            <HeaderFooter component={<CatalogueAuthSelect />}/>
            }/>
          <Route path="catalogue/search" element={
            <HeaderFooter component={<Search />}/>} />

          <Route path="catalogue/disease/" element={
            <HeaderFooter component={<Disease />}/>} />

          <Route path="catalogue/disease/:id" element={
            <HeaderFooter component={<DiseasePage />}/>} />
          
          <Route path="manage/catalogue/:uploaderId/:CatalogueId" element={
            <HeaderFooter component={<EditRoute><CatalogueManagement /></EditRoute>}/>
            }/>
          
          <Route path='manage/catalogue/disease' element={
            <HeaderFooter component={<EditRoute><DiseaseManagement /></EditRoute>}/>
          }/>
          <Route path='manage/catalogue/disease/:diseaseId' element={
            <HeaderFooter component={<EditRoute><DiseaseEdit /></EditRoute>}/>
          }/>
          <Route path="manage/catalogue/disease/diseaseadd" element={
            <HeaderFooter component={<EditRoute><DiseaseAdd /></EditRoute>}/>
          }/>
          <Route path='/mstudy' element={
            <HeaderFooter component={<MStudyList />} />
          }/>

          <Route path='/mstudy/:id' element={
            <HeaderFooter component={<MStudyPage />} />
          } />

          <Route path="*" element={
            <HeaderFooter component={<NotFound />} />
          }/>
        </Routes>    
      </BrowserRouter>
    </div>
  );
}

export default App;
